import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  loadAnalyticsStyles,
  loadAriaChatStyles,
  loadAuthenticatedShellStyles,
  loadCrmStyles,
  loadGodModeStyles,
  loadOrgChartStyles,
} from '../styles/routeStyles';

/**
 * Lazy-loads feature CSS bundles based on the current route.
 */
export default function useRouteFeatureStyles(): void {
  const { pathname } = useLocation();

  useEffect(() => {
  void loadAuthenticatedShellStyles();
  }, []);

  useEffect(() => {
    if (
      pathname.startsWith('/crm') ||
      pathname.startsWith('/entities') ||
      pathname.startsWith('/god-mode') ||
      pathname.startsWith('/settings')
    ) {
      void loadCrmStyles();
    }
    if (pathname.includes('/aria') || pathname.startsWith('/chat')) {
      void loadAriaChatStyles();
    }
    if (pathname.startsWith('/god-mode')) {
      void loadGodModeStyles();
    }
    if (pathname.startsWith('/analytics')) {
      void loadAnalyticsStyles();
    }
    if (pathname.includes('/org-chart') || pathname.includes('/teams')) {
      void loadOrgChartStyles();
    }
  }, [pathname]);

  useEffect(() => {
    void loadAriaChatStyles();
  }, []);
}
